import { render, staticRenderFns } from "./SettingsHeader.vue?vue&type=template&id=632e3761&"
import script from "./SettingsHeader.vue?vue&type=script&lang=js&"
export * from "./SettingsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports